import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/logistics-assignment')({});
